import { isProd } from '../constants/variables';
import { IEventsData, TAddToCartTemp } from './domain';

declare global {
    interface Window {
        dataLayer: {
            push: (payload: object) => void;
            length: number;
        };
        ga: {
            getAll: () => { get: (key: string) => string }[];
        };
        pageViewSended?: boolean;
        gtag?: (type: 'event', eventName: string, data: unknown) => void;
    }
}

declare let dataLayer: {
    push: (payload: object) => void;
    length: number;
};

type TBasicEvents =
    | 'purchase'
    | 'add_to_cart'
    | 'remove_from_cart'
    | 'begin_checkout'
    | 'view_item'
    | 'select_item';

const sendToPartnerGA4 = (event: TBasicEvents, data: unknown) => {
    // if partner use custom GA4 id
    if (window.gtag) {
        window.gtag('event', event, data);
    }
};

export const pushEvent = (data: IEventsData[keyof IEventsData]): void => {
    try {
        if (Object.keys(data.ecommerce_temp).length) {
            if (document?.cookie) {
                dataLayer.push({ ecommerce_temp: null }); // clear prev data, don't remove
                dataLayer.push(data); // push data
            } else {
                const clientId = window.ga?.getAll()?.[0]?.get?.('clientId');

                if (clientId) {
                    fetch(`/api/data/${clientId.replace('.', '_')}`, {
                        method: 'POST',
                        body: JSON.stringify(data),
                    });
                }
            }
        }

        if (!isProd) {
            console.log('DataLayer GA4', data); // logging for stage & dev
        }
    } catch (err) {
        console.log(`DataLayer - GA4 event is error.`, err);
    }
};

export const trackSelectItem = (data: IEventsData['select_item_temp']['ecommerce_temp']) => {
    pushEvent({
        event: 'select_item_temp',
        ecommerce_temp: data,
    });

    sendToPartnerGA4('select_item', data);
};

export const trackViewItem = (data: IEventsData['view_item_temp']['ecommerce_temp']) => {
    try {
        pushEvent({
            event: 'view_item_temp',
            ecommerce_temp: data,
        });

        sendToPartnerGA4('view_item', data);
    } catch (e) {
        console.log('GA4 trackViewItem Error: ', e);
    }
};

export const trackAddToCart = (data: TAddToCartTemp) => {
    pushEvent({
        event: 'add_to_cart_temp',
        ecommerce_temp: data,
    });

    sendToPartnerGA4('add_to_cart', data);
};
export const trackBeginCheckout = (data: IEventsData['begin_checkout_temp']['ecommerce_temp']) => {
    pushEvent({
        event: 'begin_checkout_temp',
        ecommerce_temp: data,
    });

    sendToPartnerGA4('begin_checkout', data);
};
export const trackPurchase = (data: IEventsData['purchase_temp']['ecommerce_temp']) => {
    pushEvent({
        event: 'purchase_temp',
        ecommerce_temp: data,
    });

    sendToPartnerGA4('purchase', data);
};

export const trackPageView = () => {
    pushEvent({
        event: 'page_view',
        ecommerce_temp: {
            page_location: document?.location?.href || '',
            page_title: document?.title || '',
            engagement_time_msec: 1,
        },
    });
};
